module.exports = __webpack_public_path__ + "static/media/pins.a01fcfc1.jpg";